import type { CoiSendConfig } from "@shared/coi-template";
import type { Insured } from "@shared/schema";
import type { COIIssuanceWithUser } from "@/lib/api";

export const EMPTY_COI_SEND_CONFIG: CoiSendConfig = {
  certificateHolder: "",
  selectedHolderId: null,
  holderAddress: "",
  holderCity: "",
  holderState: "",
  holderZip: "",
  recipients: [""],
  sendCopyToInsured: false,
  additionalInfo: [],
  selectedVehicleIds: [],
  selectedDriverIds: [],
  selectedTrailerIds: [],
  specialVerbiage: "",
  additionalInsuredName: "",
  additionalInsuredCoverageIds: [],
  additionalInsuredSpecialVerbiage: null,
  lossPayeeId: null,
  lossPayeeName: "",
  lossPayeeCoverageIds: [],
  lossPayeeVehicles: [],
  lossPayeeSpecialVerbiage: null,
  waiverOfSubrogationId: null,
  waiverOfSubrogationName: "",
  waiverOfSubrogationCoverageIds: [],
  waiverOfSubrogationSpecialVerbiage: null,
};

// CSR-1791: rebuild the Send COI modal config for a resend. When the issuance
// carries a full snapshot (sends after this feature shipped) it is used as-is.
// Otherwise reconstruct a best-effort config from the row's persisted columns;
// the holder address is backfilled later from the certificate-holder detail.
export function buildResendConfig(
  issuance: COIIssuanceWithUser,
  insured: Insured,
): CoiSendConfig {
  const stored = issuance.sendConfig as CoiSendConfig | null | undefined;
  if (stored) {
    return { ...EMPTY_COI_SEND_CONFIG, ...stored };
  }

  const additionalInfo = Array.isArray(issuance.additionalInfo)
    ? issuance.additionalInfo
    : [];
  const recipient = issuance.recipientEmail?.trim();
  const insuredEmail = insured.email?.trim().toLowerCase();

  return {
    ...EMPTY_COI_SEND_CONFIG,
    certificateHolder: issuance.certificateHolderName ?? "",
    selectedHolderId: issuance.certificateHolderId ?? null,
    additionalInfo,
    recipients: recipient ? [recipient] : [""],
    sendCopyToInsured: !!insuredEmail && recipient?.toLowerCase() === insuredEmail,
  };
}
